// ─── Imports ───
import ACREPR from "./ACREPR (1).png";
import APREPR from "./APREPR (1).png";
import BARBER from "./BARBER (1).png";
import BBALL from "./BBALL (1).png";
import BEAUTY from "./BEAUTY (2).png";
import CARCLN from "./CARCLN (1).png";
import CCTGRD from "./CCTGRD.png"
import COOK from "./COOK.png";
import DANCE from "./DANCE (2).png";
import DRIVER from "./DRIVER.png";
import ELCARE from "./ELCARE (1).png";
import FBALL from "./FBALL (1).png";
import FIROFF from "./FIROFF.png"
import FLOWER from "./FLOWER (2).png";
import GENMCH from "./GENMCH.png";
import GROCER from "./GROCER (1).png";
import INTRWR from "./INTRWR.png"
import LADGRD from "./LADGRD.png"
import LAUNDR from "./LAUNDR (2).png";
import MAID from "./MAID (4).png";
import MEDSHO from "./MEDSHO.png"
import MILKMN from "./MILKMN.png";
import MOVPAK from "./MOVPAK.png"
import MUSIC from "./MUSIC (2).png";
import NANNY from "./NANNY (2).png";
import NURSE from "./NURSE (3).png";
import PAINT from "./PAINT (2).png";
import PAPBOY from "./PAPBOY.png";
import PHYSIO from "./PHYSIO (3).png";
import SECGUD from "./SECGUD.png";
import SECSUP from "./SECSUP.png";
import SKATE from "./SKATE (1).png"
import SOCCLK from "./SOCCLK.png"
import SOCCRP from "./SOCCRP.png"
import SOCELE from "./SOCELE.png"
import SOCGAR from "./SOCGAR.png"
import SOCHKP from "./SOCHKP.png"
import SOCLFT from "./SOCLFT.png"
import SOCMGR from "./SOCMGR.png"
import SOCPLM from "./SOCPLM.png"
import SOCSWPR from "./SOCSWPR.png"
import STAFF from "./STAFF (2).png"
import SWEET from "./SWEET.png";
import TAEK from "./TAEK (2).png"
import TAILOR from "./TAILOR (1).png";
import TENNIS from "./TENNIS (1).png"
import TUTION from "./TUTION (1).png";
import VEGETABLE from "./VEGETABLE (3).png";
import VEGVEN from "./VEGVEN.png"
import WTCLNR from "./WTCLNR (1).png";
import YOGA from "./YOGA (1).png";
import OTHER from "./OTHER.png";
import CCTVTC from "./CCTVTC.png"

// ─── Named Export ───
export const ServiceIcons = {
  ACREPR,
  APREPR,
  BARBER,
  BBALL,
  BEAUTY,
  CARCLN,
  CCTGRD,
  COOK,
  DANCE,
  DRIVER,
  ELCARE,
  FBALL,
  FLOWER,
  FIROFF,
  GENMCH,
  GROCER,
  INTRWR,
  LADGRD,
  LAUNDR,
  MAID,
  MEDSHO,
  MILKMN,
  MOVPAK,
  MUSIC,
  NANNY,
  NURSE,
  PAINT,
  PAPBOY,
  PHYSIO,
  SECGUD,
  SECSUP,
  SKATE,
  SOCCLK,
  SOCCRP,
  SOCELE,
  SOCGAR,
  SOCHKP,
  SOCLFT,
  SOCMGR,
  SOCPLM,
  SOCSWPR,
  STAFF,
  SWEET,
  TAEK,
  TENNIS,
  TAILOR,
  TUTION,
  VEGETABLE,
  VEGVEN,
  WTCLNR,
  YOGA,
  CCTVTC,
 default: OTHER,
};